import React from 'react';
import { Link } from "react-router-dom";

const AddTeam = () => {
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-1-1">
              <div className="dashboardIntro">
                <Link to="/user">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to all teams</span>
                </Link>
                <h3>CREATE TEAM</h3>
                <p>Creating a team can help admins quickly assign the same products to a group of users.</p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Team information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Team name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Team name"
                    aria-label="Input"
                  />
                </div>

                
                
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Description <span className='uk-float-right'>(optional)</span></label>
                  <textarea className="uk-textarea" rows="5" placeholder="" aria-label="Textarea"></textarea>
                </div>
                

                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                    <div className="formActionBtn uk-text-right">
                        <button className="whiteBtn">Cancel</button>
                        <button className="pinkBtn">Save</button>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddTeam